import get from 'lodash/get';

import { SET_EDITED_BASKET, CLEAR_EDITED_BASKET } from 'actions/basketEdits';

const initialState = {
  isLoaded: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_EDITED_BASKET:
      return {
        ...state,
        isLoaded: true,
      };
    case CLEAR_EDITED_BASKET:
      return initialState;
    default:
      return state;
  }
};

export const selectBasketIsLoaded = state => get(state, 'isLoaded', false);
